"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M20 2H10L4 8v14h16zm-8 15-4-4h3V9.02L13 9v4h3z"
}), 'SimCardDownloadSharp');